export const currencyFormat = (text, currency) => {
  return text.toLocaleString({
    style: "currency",
    currency: "IDR",
  });
};
